import React from 'react';
import { formatCurrency, getCourseFeeDisplay } from '../../utils/currency';

interface CourseFeeProps {
  fee: number;
  discount?: number | null;
  showPercent?: boolean;
  layout?: 'inline' | 'stacked';
  className?: string;
}

const CourseFee: React.FC<CourseFeeProps> = ({
  fee,
  discount = 0,
  showPercent = true,
  layout = 'inline',
  className = '',
}) => {
  const { listPrice, payable, percent, hasDiscount } = getCourseFeeDisplay(fee, discount ?? 0);

  if (payable <= 0) {
    return <span className={className}>Free</span>;
  }

  if (!hasDiscount) {
    return <span className={className}>{formatCurrency(payable)}</span>;
  }

  if (layout === 'stacked') {
    return (
      <span className={className}>
        <span className="block text-xs text-gray-400 line-through">{formatCurrency(listPrice)}</span>
        <span className="block font-bold">{formatCurrency(payable)}</span>
        {showPercent ? (
          <span className="block text-[0.6875rem] font-medium text-emerald-600">{percent}% off</span>
        ) : null}
      </span>
    );
  }

  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-2 gap-y-0.5 ${className}`}>
      <span className="text-gray-400 line-through">{formatCurrency(listPrice)}</span>
      <span className="font-semibold text-gray-900">{formatCurrency(payable)}</span>
      {showPercent ? <span className="text-sm font-medium text-emerald-600">{percent}% off</span> : null}
    </span>
  );
};

export default CourseFee;
